import type { ThemeConfig } from 'antd';

// AlphaStep 管理后台 · 现代轻量 SaaS · 薄荷绿
export const BRAND_PRIMARY = '#00B96B';
export const BRAND_PRIMARY_HOVER = '#00A55E';
export const BRAND_PRIMARY_SOFT = 'rgba(0, 185, 107, 0.10)';
export const BRAND_PRIMARY_SOFT_HOVER = 'rgba(0, 185, 107, 0.06)';

export const LAYOUT_BG = '#F6F8FA';
export const HAIRLINE = '#EEF0F3';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: BRAND_PRIMARY,
    colorInfo: BRAND_PRIMARY,
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorLink: BRAND_PRIMARY,
    colorLinkHover: BRAND_PRIMARY_HOVER,

    colorBgLayout: LAYOUT_BG,
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',

    colorBorder: '#E5E7EB',
    colorBorderSecondary: HAIRLINE,

    colorText: '#0F172A',
    colorTextSecondary: '#475569',
    colorTextTertiary: '#94A3B8',
    colorTextQuaternary: '#CBD5E1',

    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,

    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 28,

    fontFamily:
      '-apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 14,
    lineHeight: 1.5715,
    wireframe: false,

    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
    boxShadowSecondary: '0 4px 16px rgba(15, 23, 42, 0.06)',
    boxShadowTertiary: '0 1px 2px rgba(15, 23, 42, 0.04)',
  },
  components: {
    Layout: {
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
      bodyBg: LAYOUT_BG,
      headerHeight: 56,
      headerPadding: '0 24px',
      triggerBg: '#FFFFFF',
      triggerColor: '#475569',
    },
    Menu: {
      itemBg: 'transparent',
      itemColor: '#475569',
      itemHoverBg: BRAND_PRIMARY_SOFT_HOVER,
      itemHoverColor: BRAND_PRIMARY,
      itemSelectedBg: BRAND_PRIMARY_SOFT,
      itemSelectedColor: BRAND_PRIMARY,
      itemActiveBg: BRAND_PRIMARY_SOFT,
      itemBorderRadius: 8,
      itemHeight: 38,
      iconSize: 16,
      subMenuItemBg: 'transparent',
      groupTitleColor: '#94A3B8',
      groupTitleFontSize: 12,
    },
    Button: {
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28,
      borderRadius: 8,
      borderRadiusLG: 10,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      fontWeight: 500,
    },
    Card: {
      borderRadiusLG: 12,
      paddingLG: 20,
      colorBorderSecondary: HAIRLINE,
      headerBg: 'transparent',
      headerFontSize: 15,
      headerFontSizeSM: 14,
    },
    Table: {
      headerBg: '#FAFBFC',
      headerColor: '#64748B',
      headerSplitColor: 'transparent',
      rowHoverBg: '#F8FAFB',
      borderColor: HAIRLINE,
      cellPaddingBlock: 12,
      cellPaddingInline: 16,
      fontSize: 14,
      headerBorderRadius: 0,
    },
    Input: {
      controlHeight: 36,
      controlHeightLG: 44,
      borderRadius: 8,
      activeBorderColor: BRAND_PRIMARY,
      hoverBorderColor: '#34D399',
      activeShadow: '0 0 0 3px rgba(0, 185, 107, 0.12)',
    },
    InputNumber: {
      controlHeight: 36,
      borderRadius: 8,
    },
    Select: {
      controlHeight: 36,
      borderRadius: 8,
      optionSelectedBg: BRAND_PRIMARY_SOFT,
      optionSelectedColor: BRAND_PRIMARY,
    },
    DatePicker: {
      controlHeight: 36,
      borderRadius: 8,
      activeBorderColor: BRAND_PRIMARY,
    },
    Tabs: {
      itemColor: '#475569',
      itemSelectedColor: BRAND_PRIMARY,
      itemHoverColor: BRAND_PRIMARY,
      inkBarColor: BRAND_PRIMARY,
      titleFontSize: 14,
      horizontalItemPadding: '12px 0',
      horizontalItemGutter: 24,
    },
    Tag: {
      borderRadiusSM: 4,
      defaultBg: '#F1F5F9',
      defaultColor: '#475569',
    },
    Statistic: {
      titleFontSize: 13,
      contentFontSize: 28,
    },
    Modal: {
      borderRadiusLG: 12,
      paddingContentHorizontalLG: 24,
    },
    Drawer: {
      borderRadiusLG: 0,
    },
    Form: {
      itemMarginBottom: 18,
      labelFontSize: 13,
      verticalLabelPadding: '0 0 6px',
    },
    Divider: {
      colorSplit: HAIRLINE,
    },
    Breadcrumb: {
      fontSize: 13,
      linkColor: '#94A3B8',
      itemColor: '#94A3B8',
      lastItemColor: '#0F172A',
      separatorColor: '#CBD5E1',
    },
    Tooltip: {
      colorBgSpotlight: '#0F172A',
      borderRadius: 6,
    },
    Avatar: {
      borderRadius: 999,
    },
    Badge: {
      colorPrimary: BRAND_PRIMARY,
    },
    Switch: {
      colorPrimary: BRAND_PRIMARY,
      colorPrimaryHover: BRAND_PRIMARY_HOVER,
    },
    Radio: {
      colorPrimary: BRAND_PRIMARY,
    },
    Checkbox: {
      colorPrimary: BRAND_PRIMARY,
      borderRadiusSM: 4,
    },
    Pagination: {
      borderRadius: 8,
      itemActiveBg: BRAND_PRIMARY_SOFT,
      colorPrimary: BRAND_PRIMARY,
    },
  },
};
